<nav
    class="navbar navbar-expand-lg bg-body-tertiary"
    [class.navbar-light]="theme.theme() !== 'dark'"
    [class.navbar-dark]="theme.theme() === 'dark'"
    [hidden]="isPublicSwpppPage() || !authentication.userId()"
    [class.d-none]="isPublicSwpppPage()"
>
    <div class="container-fluid">
        <div style="text-align: center; cursor: pointer; margin-right: 5px; font-weight: bold; color: #7e7e7e">
            <img class="nav-logo" src="./assets/logo2.png" alt="Vancon Logo" style="height: 48px; margin-top: -4px; margin-bottom: -4px; cursor: default" />
        </div>
        <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
        >
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                <li class="nav-item">
                    <a
                        class="nav-link"
                        aria-current="page"
                        routerLink="/"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        >Home</a
                    >
                </li>

                @if (
                    canViewNavLink(featureType.BidAnalyticsView, featureType.BidFabShopStockProductsView, featureType.BidViewpointDataView, featureType.BidRateDataView)
                ) {
                    <li class="nav-item dropdown">
                        <a
                            class="nav-link dropdown-toggle"
                            href="#"
                            id="navbarDropdown"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            [class.active]="isActive('bids')"
                        >
                            Bids
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            @if (canViewNavLink(featureType.BidAnalyticsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/bids/outlook">Outlook</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.BidAnalyticsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/bids/dashboard">Dashboard</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.BidAnalyticsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/bids/history">History</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.BidAnalyticsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/bids/history-validation">History Validation</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.BidAnalyticsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/bids/analytics">Analytics</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.BidAnalyticsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/bids/bidranges">Bid Ranges</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.BidAnalyticsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/bids/heavy-bid-data">Heavy Bid Data</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.BidRateDataView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/bids/bid-rate-data">Bid Rate (Beta)</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.BidAnalyticsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/bids/all-histories">Bid History Export</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.BidAnalyticsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/bids/competitor-job-bids">Competitor Bids</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.BidAnalyticsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/bids/statistical-analysis">Bid Statistical Analysis</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.BidFabShopStockProductsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/bids/fab-shop-stock-products">Fab Shop Stock Products</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.BidViewpointDataView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/bids/viewpoint-data">Viewpoint Data</a>
                                </li>
                            }
                            @if (false) {
                                <li><a class="dropdown-item" routerLink="/sourcing/expeditor-milestones">Estimators</a></li>
                            }
                        </ul>
                    </li>
                }

                @if (canViewNavLink(featureType.ToolRoomTransfers, featureType.ToolRoomRecordsView, featureType.ToolRoomRecordsEdit)) {
                    <li class="nav-item dropdown">
                        <a
                            class="nav-link dropdown-toggle"
                            href="#"
                            id="navbarDropdown"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            [class.active]="isActive('tool-room')"
                        >
                            Tool Room
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            @if (
                                canViewNavLink(
                                    featureType.ToolRoomTransfers,
                                    featureType.ToolRoomRecordsView,
                                    featureType.ToolRoomRecordsEdit
                                )
                            ) {
                                <li>
                                    <a class="dropdown-item" routerLink="/tool-room/tool-transfer">Consumable/Tool Transfer</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.ToolRoomRecordsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/tool-room/material-quantities">Consumable Quantities</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.ToolRoomRecordsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/tool-room/small-tool-locations">Small Tool Locations</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.ToolRoomRecordsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/tool-room/tool-transfer-records"
                                        >Consumable/Tool Transfer Records</a
                                    >
                                </li>
                            }
                            @if (canViewNavLink(featureType.ToolRoomEmployeeAssetsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/tool-room/employee-assets">Employee Assigned Assets</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.ToolRoomRecordsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/tool-room/barcode-manager">Barcode Manager</a>
                                </li>
                            }
                        </ul>
                    </li>
                }

                @if (
                    canViewNavLink(
                        featureType.EquipmentFuelEntryEdit,
                        featureType.EquipmentFuelRecordsView,
                        featureType.EquipmentAvailabilityView,
                        featureType.EquipmentSubCategoryPriorityView,
                        featureType.EquipmentTireManagementView,
                        featureType.EquipmentWorkOrdersView,
                        featureType.PurchasingDashboardView,
                        featureType.PurchasingPurchaseOrdersView,
                        featureType.PurchasingReceivingView,
                        featureType.PurchasingInvoicingView,
                        featureType.PurchasingQuotingView,
                        featureType.PurchasingMaterialsView
                    )
                ) {
                    <li class="nav-item dropdown">
                        <a
                            class="nav-link dropdown-toggle"
                            href="#"
                            id="navbarDropdown"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            [class.active]="isActive('equipment')"
                        >
                            Equipment
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            @if (canViewNavLink(featureType.EquipmentAvailabilityView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/equipment/availability">Equipment List</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.EquipmentWorkOrdersView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/equipment/work-order-queue">Work Order Queue</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.EquipmentAvailabilityView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/equipment/scheduling">Scheduling (Beta)</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.EquipmentReportView)) {
                                <li class="dropdown-submenu">
                                    <a class="dropdown-item dropdown-toggle" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                        Equipment Reports
                                    </a>
                                    <ul class="dropdown-menu">
                                        <li>
                                            <a class="dropdown-item" routerLink="/equipment/equipment-report">Equipment Summary</a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item" routerLink="/equipment/equipment-cost-revenue"
                                                >Equipment Cost-Revenue</a
                                            >
                                        </li>
                                        <li>
                                            <a class="dropdown-item" routerLink="/equipment/equipment-warranty">Equipment Warranty</a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item" routerLink="/equipment/equipment-work-orders"
                                                >Equipment Work Orders / Preventative Maintenance</a
                                            >
                                        </li>
                                    </ul>
                                </li>
                            }
                            @if (canViewNavLink(featureType.EquipmentFuelEntryEdit)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/equipment/fuel-entry">Fuel Entry</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.EquipmentFuelRecordsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/equipment/fuel-records">Fuel Records</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.EquipmentFuelRecordsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/equipment/fuel-analytics">Fuel Analytics</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.EquipmentFuelRecordsEdit)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/equipment/lifetime-meter-entry">Lifetime Meter Entry</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.EquipmentAvailabilityView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/equipment/equipment-analytics">Equipment Analytics</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.EquipmentFuelRecordsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/equipment/qr-codes">QR Codes</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.EquipmentSubCategoryPriorityView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/equipment/sub-category-priority">Sub-Category Priority</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.EquipmentTireManagementView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/equipment/tire-management">Tire Management (Beta)</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.EquipmentPartsFluidsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/equipment/parts-fluids">Parts &amp; Fluids (Beta)</a>
                                </li>
                                <li>
                                    <a class="dropdown-item" routerLink="/equipment/parts-fluids-lookup">Parts &amp; Fluids Lookup (Beta)</a>
                                </li>
                            }
                            @if (
                                canViewNavLink(
                                    featureType.PurchasingDashboardView,
                                    featureType.PurchasingPurchaseOrdersView,
                                    featureType.PurchasingReceivingView,
                                    featureType.PurchasingInvoicingView,
                                    featureType.PurchasingQuotingView
                                )
                            ) {
                                <li><hr class="dropdown-divider" /></li>
                                <li>
                                    <a class="dropdown-item" routerLink="/purchasing">Purchasing</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.PurchasingMaterialsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/equipment/purchased-materials">Materials (Beta)</a>
                                </li>
                            }
                        </ul>
                    </li>
                }

                @if (
                    canViewNavLink(
                        featureType.EquipmentAvailabilityView,
                        featureType.OperationsRentalsView,
                        featureType.OperationsMaterialsView,
                        featureType.OperationsSchedulingView,
                        featureType.OperationsProjectionsView,
                        featureType.OperationsLeadershipTeamVisitsView,
                        featureType.OperationsLeadershipTeamVisitsDashboardView
                    )
                ) {
                    <li class="nav-item dropdown">
                        <a
                            class="nav-link dropdown-toggle"
                            href="#"
                            id="navbarDropdown"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            [class.active]="isActive('operations')"
                        >
                            Operations
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            @if (canViewNavLink(featureType.EquipmentAvailabilityView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/operations/availability">Equipment Availability</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.OperationsRentalsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/operations/rentals">Rentals</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.OperationsMaterialsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/operations/materials">Materials</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.OperationsSchedulingView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/operations/scheduling">Scheduling</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.OperationsProjectionsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/operations/fte-projections">FTE Projections</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.OperationsMaterialsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/operations/material-analytics">Material Analytics</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.OperationsMaterialsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/operations/firm-contacts">Firm Contacts</a>
                                </li>
                            }
                            @if (
                                canViewNavLink(
                                    featureType.OperationsLeadershipTeamVisitsView,
                                    featureType.OperationsLeadershipTeamVisitsDashboardView
                                )
                            ) {
                                <li>
                                    <a class="dropdown-item" routerLink="/operations/leadership-team-visits">Leadership Team Visits (Beta)</a>
                                </li>
                            }
                        </ul>
                    </li>
                }

                @if (
                    canViewNavLink(
                        featureType.OperationsProjectionsView,
                        featureType.OperationsWipReportView,
                        featureType.OperationsPmJcaReportView,
                        featureType.OperationsJobOwnershipsView,
                        featureType.OperationsJobOwnershipTemplatesView,
                        featureType.ProjectManagementProductivityView
                    )
                ) {
                    <li class="nav-item dropdown">
                        <a
                            class="nav-link dropdown-toggle"
                            href="#"
                            id="navbarDropdown"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            [class.active]="isActive('project-management')"
                        >
                            Project Management
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            @if (canViewNavLink(featureType.OperationsProjectionsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/operations/projections">Revenue/Cost</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.OperationsProjectionsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/operations/projected-hours">Projected Hours</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.OperationsWipReportView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/operations/wip-report">WIP Report</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.OperationsPmJcaReportView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/operations/pm-jca-report">PM/JCA Report</a>
                                </li>
                            }
                            <!-- @if (canViewNavLink(featureType.OperationsProjectionsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/operations/productivity-analysis">Productivity Analysis</a>
                                </li>
                            } -->
                            @if (canViewNavLink(featureType.ProjectManagementProductivityView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/operations/productivity-summary">Productivity Summary</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.OperationsManpowerOutliersView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/operations/manpower-outliers">Manpower Outliers</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.OperationsJobOwnershipsView, featureType.OperationsJobOwnershipTemplatesView)) {
                                <li class="dropdown-submenu">
                                    <a
                                        class="dropdown-item dropdown-toggle"
                                        routerLink="/operations/job-ownerships"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        Job Ownerships
                                    </a>
                                    <ul class="dropdown-menu">
                                        @if (canViewNavLink(featureType.OperationsJobOwnershipsView)) {
                                            <li>
                                                <a class="dropdown-item" routerLink="/operations/job-ownerships">Ownerships</a>
                                            </li>
                                        }
                                        @if (canViewNavLink(featureType.OperationsJobOwnershipTemplatesView)) {
                                            <li>
                                                <a class="dropdown-item" routerLink="/operations/job-ownership-templates"
                                                    >Ownership Templates</a
                                                >
                                            </li>
                                        }
                                    </ul>
                                </li>
                            }

                            @if (canViewNavLink(featureType.FieldToolsPendingChangeOrdersView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/field-tools/pending-change-orders">Pending Change Orders</a>
                                </li>
                            }
                        </ul>
                    </li>
                }

                <li class="nav-item dropdown">
                    <a
                        class="nav-link dropdown-toggle"
                        href="#"
                        id="navbarDropdown"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        [class.active]="isActive('field-tools')"
                    >
                        Field Tools
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        @if (canViewNavLink(featureType.FieldToolsEquipmentReportView)) {
                            <li class="dropdown-submenu">
                                <a
                                    class="dropdown-item dropdown-toggle"
                                    routerLink="/field-tools/equipment-report"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Equipment Report (Beta)
                                </a>
                                <ul class="dropdown-menu">
                                    <li>
                                        <a class="dropdown-item" routerLink="/field-tools/equipment-report/list">List of Reports</a>
                                    </li>
                                </ul>
                            </li>
                        }
                        <li>
                            <a class="dropdown-item" routerLink="/field-tools/plans-and-specs">Plans and Specs</a>
                        </li>
                        @if (canViewNavLink(featureType.FieldToolsPlansAndSpecsView)) {
                            <li>
                                <a class="dropdown-item" routerLink="/field-tools/quality-control">Quality Control</a>
                            </li>
                        }

                        @if (canViewNavLink(featureType.FieldToolsPlansAndSpecsView)) {
                            <li class="dropdown-submenu">
                                <a
                                    class="dropdown-item dropdown-toggle"
                                    routerLink="/field-tools/purchase-orders"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Purchase Orders (Beta)
                                </a>
                                <ul class="dropdown-menu">
                                    <li>
                                        <a class="dropdown-item" routerLink="/field-tools/purchase-orders/list">List of POs</a>
                                    </li>
                                </ul>
                            </li>
                        }

                        @if (canViewNavLink(featureType.FieldToolsSiteConditionChangeView)) {
                            <li>
                                <a class="dropdown-item" routerLink="/field-tools/pending-change-orders-field">Site Condition Change</a>
                            </li>
                        }

                        @if (canViewNavLink(featureType.FieldToolsBlueStakesLogView)) {
                            <li>
                                <a class="dropdown-item" routerLink="/field-tools/blue-stakes-log">Blue Stakes Log</a>
                            </li>
                        }

                        @if (
                            canViewNavLink(featureType.FieldToolsDamagedUtilityLogView) ||
                            canViewNavLink(featureType.FieldToolsDamagedUtilityLogDashboardView)
                        ) {
                            <li>
                                <a class="dropdown-item" routerLink="/field-tools/damaged-utility-log">Damaged Utility Log</a>
                            </li>
                        }

                        @if (canViewNavLink(featureType.FieldToolsPunchListView)) {
                            <li>
                                <a class="dropdown-item" routerLink="/field-tools/punch-list">Punch List</a>
                            </li>
                        }

                        @if (canViewNavLink(featureType.FieldToolsSwpppView) || canViewNavLink(featureType.FieldToolsSwpppDashboardView)) {
                            <li>
                                <a class="dropdown-item" routerLink="/field-tools/swppp">SWPPP (Beta)</a>
                            </li>
                        }

                        @if (canViewNavLink(featureType.FieldToolsForemanScheduleView)) {
                            <li>
                                <a class="dropdown-item" routerLink="/field-tools/foreman-schedule">Foreman Schedule</a>
                            </li>
                        }

                        @if (canViewNavLink(featureType.FieldToolsPoConfigEdit)) {
                            <li><hr class="dropdown-divider" /></li>
                            <li>
                                <a class="dropdown-item" routerLink="/field-tools/job-type-vendor-templates">Job Type Vendor Templates</a>
                            </li>
                        }
                        @if (canViewNavLink(featureType.FieldToolsPoConfigView)) {
                            <li>
                                <a class="dropdown-item" routerLink="/field-tools/job-po-configuration">Job PO Configuration</a>
                            </li>
                        }
                    </ul>
                </li>

                @if (
                    canViewNavLink(
                        featureType.FabBoardView,
                        featureType.FabSetupView,
                        featureType.FabDraftingQueueView,
                        featureType.FabShopFloorView,
                        featureType.FabDeliveryLookaheadView,
                        featureType.FabHoldsView
                    )
                ) {
                    <li class="nav-item dropdown">
                        <a
                            class="nav-link dropdown-toggle"
                            href="#"
                            id="navbarDropdownFab"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            [class.active]="isActive('fab')"
                        >
                            Fab
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdownFab">
                            @if (canViewNavLink(featureType.FabBoardView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/fab/board">Board (Beta)</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.FabDraftingQueueView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/fab/drafting">Drafting Queue (Beta)</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.FabShopFloorView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/fab/shop">Shop Floor (Beta)</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.FabShopFloorView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/fab/shop-quick">Shop Quick (Beta)</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.FabDeliveryLookaheadView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/fab/deliveries">Delivery Lookahead (Beta)</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.FabHoldsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/fab/holds">Holds &amp; Constraints (Beta)</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.FabSetupView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/fab/setup">Setup (Beta)</a>
                                </li>
                            }
                        </ul>
                    </li>
                }

                @if (
                    canViewNavLink(featureType.MeetingsMeetingView, featureType.MeetingsMeetingEdit, featureType.MeetingsBusinessPlanView)
                ) {
                    <li class="nav-item dropdown">
                        <a
                            class="nav-link dropdown-toggle"
                            href="#"
                            id="navbarDropdown"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            [class.active]="isActive('meetings')"
                        >
                            Meetings
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            @if (canViewNavLink(featureType.MeetingsMeetingView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/meetings/meetings">Meetings</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.MeetingsBusinessPlanView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/meetings/business-plan">Business Plan</a>
                                </li>
                            }
                        </ul>
                    </li>
                }

                @if (false) {
                    <li class="nav-item dropdown">
                        <a
                            class="nav-link dropdown-toggle"
                            href="#"
                            id="navbarDropdown"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            [class.active]="isActive('data')"
                        >
                            Fleet
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <li><a class="dropdown-item" routerLink="/data/item-master">Maintenance</a></li>
                            <li><a class="dropdown-item" routerLink="/data/order-data">Work Orders</a></li>
                        </ul>
                    </li>
                }

                @if (canViewNavLink(featureType.BidAnalyticsView)) {
                    <li class="nav-item dropdown">
                        <a
                            class="nav-link dropdown-toggle"
                            href="#"
                            id="navbarDropdown"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            [class.active]="isActive('analytics')"
                        >
                            Analytics
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <li><a class="dropdown-item" routerLink="/analytics/phase-costs">Phase Costs</a></li>
                        </ul>
                    </li>
                }

                @if (
                    canViewNavLink(
                        featureType.SafetyDashboardView,
                        featureType.SafetyJobHazardAnalysisView,
                        featureType.SafetyJobHazardAnalysisDashboardView,
                        featureType.SubcontractorTrainingView,
                        featureType.SafetyVehicleInspectionView,
                        featureType.SafetyFeedbackView,
                        featureType.SafetyFeedbackEdit,
                        featureType.SafetyAutoAccidentReportView,
                        featureType.SafetyAutoAccidentReportDashboardView,
                        featureType.SafetyIncidentInvestigationView,
                        featureType.SafetyIncidentInvestigationDashboardView,
                        featureType.SafetyChecklistView,
                        featureType.SafetyChecklistDashboardView,
                        featureType.UsersView
                    )
                ) {
                    <li class="nav-item dropdown">
                        <a
                            class="nav-link dropdown-toggle"
                            href="#"
                            id="navbarDropdown"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            [class.active]="isActive('safety')"
                        >
                            Safety
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            @if (canViewNavLink(featureType.SafetyDashboardView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/safety/dashboard">Dashboard</a>
                                </li>
                            }
                            @if (
                                canViewNavLink(featureType.SafetyJobHazardAnalysisView, featureType.SafetyJobHazardAnalysisDashboardView)
                            ) {
                                <li>
                                    <a class="dropdown-item" routerLink="/safety/job-hazard-analysis">Job Hazard Analysis</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.SafetyVehicleInspectionView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/safety/vehicle-inspection">Vehicle Inspection</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.SubcontractorTrainingView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/safety/subcontractor-training">Subcontractor Training</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.SafetyFeedbackView, featureType.SafetyFeedbackEdit)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/safety/safety-feedback">Safety Feedback</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.SafetyAutoAccidentReportView, featureType.SafetyAutoAccidentReportDashboardView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/safety/auto-accident-report">Auto Accident Report (Beta)</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.SafetyIncidentInvestigationView, featureType.SafetyIncidentInvestigationDashboardView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/safety/incident-investigation">Incident Investigation (Beta)</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.SafetyChecklistView, featureType.SafetyChecklistDashboardView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/safety/safety-checklists">Safety Checklists (Beta)</a>
                                </li>
                            }
                        </ul>
                    </li>
                }

                @if (
                    canViewNavLink(
                        featureType.HrSafetyView,
                        featureType.HrRetentionView,
                        featureType.HrScorecardGoalsView,
                        featureType.HrScorecardHiringView,
                        featureType.HrScorecardAdminView,
                        featureType.HrAccountabilityChartView,
                        featureType.HrDisciplinaryActionView
                    )
                ) {
                    <li class="nav-item dropdown">
                        <a
                            class="nav-link dropdown-toggle"
                            href="#"
                            id="navbarDropdown"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            [class.active]="isActive('hr')"
                        >
                            HR
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            @if (
                                canViewNavLink(
                                    featureType.HrScorecardGoalsView,
                                    featureType.HrScorecardHiringView,
                                    featureType.HrScorecardAdminView
                                )
                            ) {
                                <li>
                                    <a class="dropdown-item" routerLink="/hr/scorecard">Scorecard</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.HrRetentionView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/hr/retention">Retention</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.HrSafetyView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/hr/safety">Safety</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.HrAccountabilityChartView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/hr/org-chart">Accountability Chart</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.HrNotificationView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/hr/notifications">Notifications</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.HrGroupsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/hr/groups">Groups</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.HrDisciplinaryActionView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="/hr/disciplinary-action">Disciplinary Action (Beta)</a>
                                </li>
                            }
                        </ul>
                    </li>
                }

                @if (canViewNavLink(featureType.UsersView, featureType.RolesRightsView, featureType.EquipmentFuelEntryEdit)) {
                    <li class="nav-item dropdown">
                        <a
                            class="nav-link dropdown-toggle"
                            href="#"
                            id="navbarDropdown"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            [class.active]="isActive('admin')"
                        >
                            Admin
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            @if (canViewNavLink(featureType.UsersView)) {
                                <li><a class="dropdown-item" routerLink="admin/users">Users</a></li>
                            }
                            @if (canViewNavLink(featureType.RolesRightsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="admin/roles">Roles/Rights</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.UsersView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="admin/jobtypes">Job Types</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.UsersView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="admin/counties">Counties</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.AdminDivisionsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="admin/divisions">Divisions (Beta)</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.UsersView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="admin/actions">Actions</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.UsersView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="admin/validation">Validation</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.EquipmentFuelEntryEdit)) {
                                <li>
                                    <a class="dropdown-item" routerLink="admin/fuel-record-defaults">Fuel Record Defaults</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.UsersView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="admin/vendors">Vendors</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.UsersView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="admin/company-quarters">Company Quarters</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.UsersView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="admin/quarterly-measurables">Quarterly Measurables</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.UsersView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="admin/metrics">Metric Manager</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.MeetingsBusinessPlanEdit)) {
                                <li>
                                    <a class="dropdown-item" routerLink="admin/business-plan-sections">Business Plan Sections</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.UsersView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="admin/hcss-api-test">HCSS API Test</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.UsersView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="admin/ai-poc">AI POC</a>
                                </li>
                            }
                            @if (canViewNavLink(featureType.AdminVistaUploadsView)) {
                                <li>
                                    <a class="dropdown-item" routerLink="admin/vista-uploads">Vista Uploads (Beta)</a>
                                </li>
                            }

                            @if (canViewNavLink(featureType.AdminPlansView)) {
                                <li class="dropdown-submenu">
                                    <a class="dropdown-item dropdown-toggle" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                        Plans
                                    </a>
                                    <ul class="dropdown-menu">
                                        <li>
                                            <a class="dropdown-item" routerLink="admin/plans/procure-to-pay">Procure to Pay</a>
                                        </li>
                                    </ul>
                                </li>
                            }

                            @if (canViewNavLink(featureType.OperationsBonusTableViewEdit, featureType.OperationsBonusTableViewEdit)) {
                                <li class="dropdown-submenu">
                                    <a class="dropdown-item dropdown-toggle" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                        Bonus Table
                                    </a>
                                    <ul class="dropdown-menu">
                                        @if (canViewNavLink(featureType.OperationsBonusTableViewEdit)) {
                                            <li>
                                                <a class="dropdown-item" routerLink="/operations/bonus-table">Bonus Table</a>
                                            </li>
                                        }
                                        @if (canViewNavLink(featureType.OperationsBonusTableViewEdit)) {
                                            <li>
                                                <a class="dropdown-item" routerLink="/operations/monthly-plans">Monthly Plans</a>
                                            </li>
                                        }
                                    </ul>
                                </li>
                            }
                        </ul>
                    </li>
                }
            </ul>
            @if (authentication.firstName()) {
                <button type="button" class="nav-appearance me-2" title="Appearance" aria-label="Appearance settings" (click)="openAppearance()">
                    <fa-icon [icon]="faGear"></fa-icon>
                </button>
                <span
                    class="d-none d-lg-inline nav-cache-expiry me-2"
                    [title]="cacheExpirationDate() ? getCacheRefreshTooltip(cacheExpirationDate()!) : 'Loading...'"
                    (mouseenter)="loadCacheExpiration()"
                >
                    <fa-icon [icon]="faClock"></fa-icon>
                </span>
                <p class="nav navbar-text navbar-right user-name">Hello, {{ authentication.firstName() }}</p>
            }
            @if (authentication.firstName()) {
                <button class="btn btn-secondary btn-sm" style="margin-left: 10px" (click)="logout()">Logout</button>
            }
        </div>
    </div>
</nav>
